import { GREY_300, LIGHT_GREY, WHITE, WHITE_200 } from '@propertypal/shared/src/styles/theme';
import React, { FunctionComponent } from 'react';
import Button, { Props } from './Button';

const BORDER_STYLE = {
  border: `1px solid ${LIGHT_GREY}`,
};

const WhiteButton: FunctionComponent<Props> = (props) => {
  return (
    <Button
      {...props}
      containerStyle={{ ...BORDER_STYLE, color: GREY_300, ...props.containerStyle }}
      color={WHITE}
      fontColor={GREY_300}
      hoverColor={WHITE_200}
      disableClassName
    />
  );
};

export default WhiteButton;
